export default "__VITE_ASSET__BuNXk8lK__"